import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import {
    Space,
    Zone,
    Visit,
    SpaceService,
    ZoneService,
    VisitService,
    ViewerService,
    NavigatorService,
} from "@smarterplan/ngx-smarterplan-core";
import { Subscription } from "rxjs";

@Component({
    selector: "app-navigation-bar",
    templateUrl: "./navigation-bar.component.html",
    styleUrls: ["./navigation-bar.component.scss"],
})
export class NavigationBarComponent implements OnInit {
    @ViewChild("navbarSelectMenu") navbarSelectMenu!: any;

    locations: Space[];

    spaceSubscription: Subscription;

    viewerSubscription: Subscription;

    locationIDSubscription: Subscription;

    currentLocationID: string;

    currentModel3d: string;

    selectedLocation: Space = null;

    selectedModel3d: string;

    selectedFloor: Zone = null;

    selectedZone: Zone = null;

    selectedChildZone: Zone = null;

    visitsPerSpace: Visit[] = null;

    floorsPerSpace: Zone[] = null;

    zonesPerSpace: Zone[] = null;

    zonesPerFloor: Zone[] = null;

    childrenZones: Zone[] = null;

    sweepToGo: string;

    floorToGo: Zone;

    constructor(
        private router: Router,
        private spaceService: SpaceService,
        private zoneService: ZoneService,
        private visitService: VisitService,
        private viewerService: ViewerService,
        private navigatorService: NavigatorService,
    ) {
        this.spaceSubscription = this.spaceService.locationUpdated.subscribe(
            (locs) => {
                this.locations = locs;
                if (this.selectedLocation) {
                    this.selectedLocation = this.findLocationByID(
                        this.selectedLocation.id,
                    ); // Update Object (object address will change);
                }
            },
        );
        this.viewerSubscription = this.viewerService.viewerIsOn.subscribe(
            (data: {
                spaceID: string;
                model3D: string;
                sweep: string | null;
            }) => {
                console.log("menu navigation received update", data);
                this.currentLocationID = data.spaceID;
                this.currentModel3d = data.model3D;
                if (!data.spaceID) {
                    this.selectedLocation = null;
                    this.sendUpdateLocationEvent();
                    return;
                }
                if (
                    (!this.selectedLocation ||
                        this.selectedLocation.id !== data.spaceID) &&
                    this.locations
                ) {
                    this.selectedLocation = this.findLocationByID(data.spaceID);
                    this.sendUpdateLocationEvent();
                }
            },
        );

        /**
         * We listen for Location change event
         */
        this.locationIDSubscription =
            this.navigatorService.locationIDChange.subscribe((id: string) => {
                this.clearData();
                this.selectedLocation = this.findLocationByID(id);
                this.navigatorService.currentNavBarLocationID = id;
                this.onSelectedLocationChanged();
            });
    }

    ngOnInit() {
        this.initLocations();
    }

    ngOnDestroy() {
        this.spaceSubscription.unsubscribe();
        this.viewerSubscription.unsubscribe();
        this.locationIDSubscription.unsubscribe();
    }

    async initLocations() {
        this.locations = this.spaceService.locationsForUser;
        if (this.locations.length === 0) {
            this.locations =
                await this.spaceService.getLocationsForCurrentUser();
        }
        if (this.currentLocationID && this.locations.length > 0) {
            this.selectedLocation = this.findLocationByID(
                this.currentLocationID,
            );
            if (this.selectedLocation) {
                this.sendUpdateLocationEvent();
            }
        }
    }

    /**
     * Find a location with a given ID
     * @param id ID for the location
     * @returns The location or null if no location were found
     */
    findLocationByID(id: string): Space {
        const space = this.locations.find((loc) => loc.id === id);
        return space || null; /** Convert to null if undefined */
    }

    clearData(clearVisits = true) {
        this.floorsPerSpace = null;
        this.selectedFloor = null;
        this.zonesPerFloor = null;
        this.childrenZones = null;
        this.selectedModel3d = null;
        this.sweepToGo = null;
        this.floorToGo = null;
        this.selectedZone = null;
        this.selectedChildZone = null;
        if (clearVisits) {
            this.visitsPerSpace = null;
            this.zonesPerSpace = null;
        }
    }

    /**
     * When the selectedLocation changes
     * Send a event to locationIDChange from NavigatorService
     * The event will be catch by this component and the filter bar will be update
     */
    sendUpdateLocationEvent() {
        const locationID = this.selectedLocation
            ? this.selectedLocation.id
            : null;
        this.navigatorService.locationIDChange.next(locationID);
    }

    async onSelectedLocationChanged() {
        if (!this.selectedLocation) {
            return;
        }
        try {
            this.visitsPerSpace =
                await this.visitService.getVisitsForSpaceForUser(
                    this.selectedLocation.id,
                );
            this.zonesPerSpace = await this.zoneService.getZonesBySpaceForUser(
                this.selectedLocation.id,
            );
            if (this.visitsPerSpace.length === 1) {
                this.selectedModel3d = this.visitsPerSpace[0].model3d;
                this.floorsPerSpace = this.zonesPerSpace.filter(
                    (zone) => zone.layer && zone.layer.name.includes("FLOOR"),
                );
                if (this.floorsPerSpace.length === 1) {
                    [this.selectedFloor] = this.floorsPerSpace;
                    this.onFloorClick(false);
                }
            }
        } catch (error) {
            console.log("error onChosenLocation", error);
        }
    }

    async onLocationClick() {
        this.clearData();
        await this.sendUpdateLocationEvent();
    }

    async onFloorClick(emitEvent = true) {
        this.sweepToGo = null;
        this.selectedZone = null;
        this.selectedChildZone = null;
        if (this.selectedFloor === null) {
            this.navigatorService.navBarZoneIDChange.next(null);
            this.navigatorService.currentNavBarZoneID = null;
            return;
        }
        if (emitEvent) {
            this.navigatorService.navBarZoneIDChange.next(
                this.selectedFloor.id,
            );
        }

        this.navigatorService.currentNavBarZoneID = this.selectedFloor.id;
        this.zonesPerFloor = this.zonesPerSpace.filter(
            (zone) =>
                // zone.id === this.selectedFloor.id ||
                zone.parentID === this.selectedFloor.id,
        );
    }

    async onZoneClick() {
        this.selectedChildZone = null;
        if (this.selectedZone === null) {
            if (this.selectedFloor === null) {
                this.navigatorService.navBarZoneIDChange.next(null);
                this.navigatorService.currentNavBarZoneID = null;
            } else {
                this.navigatorService.navBarZoneIDChange.next(
                    this.selectedFloor.id,
                );
                this.navigatorService.currentNavBarZoneID =
                    this.selectedFloor.id;
            }
            return;
        }
        this.childrenZones = this.zonesPerSpace.filter(
            (zone) => zone.parentID === this.selectedZone.id,
        );
        this.navigatorService.navBarZoneIDChange.next(this.selectedZone.id);
        this.navigatorService.currentNavBarZoneID = this.selectedZone.id;
    }

    async onVisitClick(event) {
        this.clearData(false);
        const index = event.target.value;
        const visit = this.visitsPerSpace[index];
        this.selectedModel3d = visit.model3d;
        const parentZoneForVisit =
            await this.visitService.getDefaultZoneForVisit(visit);
        this.floorsPerSpace = this.zonesPerSpace.filter(
            (zone) =>
                zone.layer &&
                zone.layer.name.includes("FLOOR") &&
                zone.parentID === parentZoneForVisit.id,
        );
    }

    goTo() {
        if (this.selectedZone && !this.selectedZone.virtual) {
            if (this.selectedChildZone) {
                this.sweepToGo = this.selectedChildZone.startSweepID
                    ? this.selectedChildZone.startSweepID
                    : this.selectedChildZone.sweepIDs[0];
            } else {
                this.sweepToGo = this.selectedZone.startSweepID
                    ? this.selectedZone.startSweepID
                    : this.selectedZone.sweepIDs[0];
            }
        }
        if (this.selectedFloor && !this.selectedZone) {
            this.floorToGo = this.selectedFloor;
        }
        if (this.isWithinSameVisit()) {
            this.goToSweepOrFloor();
        } else {
            if (this.sweepToGo) {
                this.viewerService.setSweepToMove(this.sweepToGo);
            }
            if (this.floorToGo && this.floorsPerSpace.length !== 1) {
                this.navigatorService.floorToGo = this.floorToGo;
            }
            this.router.navigate(["museum", this.selectedLocation.id], {
                queryParams: { model3D: this.selectedModel3d },
            });
        }
    }

    isWithinSameVisit(): boolean {
        return (
            this.currentLocationID === this.selectedLocation.id &&
            this.selectedModel3d === this.currentModel3d
        );
    }

    goToSweepOrFloor() {
        if (this.sweepToGo) {
            this.navigatorService.goToSweepWithRotation(this.sweepToGo);
        }
        if (this.floorToGo) {
            this.navigatorService.goToFloor(this.floorToGo);
        }
    }

    canGo(): boolean {
        const viewerIsReady =
            this.viewerService.isLoaded && this.viewerService.showingViewer;
        const noViewer = !this.viewerService.showingViewer;
        return viewerIsReady || noViewer;
    }

    showLocation(): string {
        if (
            window.innerWidth < 750 &&
            this.navbarSelectMenu &&
            this.navbarSelectMenu.nativeElement.className.search("show") ===
            -1 &&
            this.selectedLocation
        ) {
            return this.selectedLocation.name;
        }
        return "";
    }
}
